import { Box, ButtonGroup, Icon, IconButton, Tooltip } from "@chakra-ui/react"
import { useEffect } from "react"
import { FaRotateLeft, FaTrash } from "react-icons/fa6"
import { FiEdit3 } from "react-icons/fi"
import { GiCheckMark } from "react-icons/gi"
import { useAlert } from "../../../../hooks/useAlert"
import { useColletion } from "../../../../hooks/usePocketBase"
import { Tarefa } from "../../../../types/tarefas"
import { useAuthStore } from "../../../../zustand/useAuthStore"
import { VisualizarTarefaC } from "./visualizar"

export interface VisualizarTarefaProps {
    onClose: () => void,
    onEdit: (aviso: any) => void,
    data: Tarefa
}

export const VisualizarTarefa = ({ onClose, onEdit, data }: VisualizarTarefaProps) => {

    const { success, warning } = useAlert()
    const { updateDoc, getDocs } = useColletion('tarefas')
    const { usuario } = useAuthStore();

    const isMe = (item: Tarefa) => {
        if (item?.usuario === usuario?.id) {
            return true
        } else {
            return false;
        }
    };
    const _handleReloadTarefa = async (data: Tarefa) => {
        let response = await updateDoc(data.id, { finalizado: false, finalizado_em: undefined })
        if (response.id) {
            onClose()
        }
    }

    useEffect(() => {
        isMe(data)
    }, [])

    const _onFinish = async () => {
        const response = await updateDoc(data.id, { finalizado: true, finalizado_em: new Date() });
        if (response.id) {
            success('Finalizado com sucesso.');
            onClose();
        } else {
            warning('Verifique e tente novamente.')
        }
    }

    const onDelete = async () => {
        let response = await updateDoc(data.id, { hidden: true });
        if (response.id) {
            success('Excluído com sucesso.');
            onClose();
        } else {
            warning('Verifique e tente novamente.')
        }
    }

    return (
        <Box
            w={`100%`}
            h={`100%`}
        >
            <VisualizarTarefaC data={data} />
            {isMe(data) &&
                <ButtonGroup w={`100%`} display={`flex`} alignItems={`baseline`} justifyContent={`flex-end`} py={5}>
                    {data && !data?.finalizado &&
                        <Tooltip label="Editar Tarefa">
                            <IconButton
                                size={`sm`}
                                aria-label="Editar Tarefa"
                                icon={<Icon as={FiEdit3} w={6} h={6} color={`blue.400`} />}
                                onClick={() => onEdit(data)}
                            />
                        </Tooltip>
                    }
                    {data && data?.finalizado && isMe(data) &&
                        <Tooltip label="Marcar como não executada">
                            <IconButton
                                size={`sm`}
                                aria-label="Marcar como não executada"
                                icon={<Icon as={FaRotateLeft} w={6} h={6} color={`blue.400`} />}
                                onClick={() => _handleReloadTarefa(data)}
                            />
                        </Tooltip>
                    }
                    {data && !data?.finalizado && isMe(data) &&
                        <Tooltip label="Marcar como executada">
                            <IconButton
                                size={`sm`}
                                aria-label="Marcar como executada"
                                icon={<Icon as={GiCheckMark} w={6} h={6} color={`green.500`} />}
                                onClick={_onFinish}
                            />
                        </Tooltip>
                    }
                    {isMe(data) &&
                        <Tooltip label="Excluir Tarefa">
                            <IconButton
                                size={`sm`}
                                aria-label="Excluir Tarefa"
                                icon={<Icon as={FaTrash} w={6} h={6} color={`red.500`} />}
                                onClick={onDelete}
                            />
                        </Tooltip>
                    }
                </ButtonGroup>
            }
        </Box>
    )
}